import $ from 'jquery';

$(document).ready(function() {

    function homeResourcesSection() {
        $('.homeResourcesSection__nav').appendTo(innerWidth < 720 ? $('.homeResourcesSection__inner') : $('.homeResourcesSection__content'));
    }
    homeResourcesSection();
    $(window).on('resize', homeResourcesSection);
});